export type SuntraceMinimapMarkerFrame = {
  playerTrackProgress: number;
  rivals: readonly {
    id: string;
    trackProgress: number;
    visible: boolean;
  }[];
};

export const normalizeMinimapProgress = (progress: number): number =>
  Number.isFinite(progress) ? ((progress % 1) + 1) % 1 : 0;

export const getMinimapPathDistance = (
  progress: number,
  totalLength: number,
): number =>
  normalizeMinimapProgress(progress) *
  (Number.isFinite(totalLength) ? Math.max(0, totalLength) : 0);
